import Hero from "./hero";
export default Hero;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/hero/index.ts
// module id = D6q0
// module chunks = 2